module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460957.00e90c59.png";